import UiStateStore from './stores/ui-state-store';
import ParamStore from '../logic/stores/param-store';
import ModelStore from '../logic/stores/model-store';
import BubblePositionCalculator from './bubble-position-calculator';
import LoginBubble from '../components/login-bubble';
import LoginForm from '../components/login-form';
import InitialCohort from '../constants/initial-cohort';
import LocalizationFactory from '../infrastructure/localization';
import PasswordMode from '../constants/password-mode';
import FormUiState from './form-ui-state';
import TrackingAction from '../constants/tracking-action';
import FormType from '../constants/form-type';
import JmServices from '../ws/jm-services';
import ErrorLogger from '../infrastructure/error-logger';
import FormActions from '../logic/form-actions';

export default class UiActions {

    static getClsLoginUrl(componentId) {
        return ParamStore.getModel(componentId).clsLoginUrl;
    }

    static createForm(placeHolder, params, componentId) {
        UiActions._registerComponent(componentId);
        UiActions._validateAndStoreGlobalParams(params, componentId);

        if (ModelStore.getModel(componentId).formType === FormType.register) {
            JmServices.trackEvent(componentId, { trackingValue: TrackingAction.jlsRegisterViewLoaded });
        }

        UiStateStore.update(componentId, (model) => {
            model.form.formPlaceholder = placeHolder;
        });

        ReactDOM.render(
            <LoginForm componentId={componentId} />,
            UiStateStore.getModel(componentId).form.formPlaceholder
        );
    }

    static initBubble(placeHolder, params, componentId) {
        UiActions._registerComponent(componentId);

        try {
            UiActions._validateAndStoreGlobalParams(params, componentId);

            window.Object.defineProperty( Element.prototype, 'documentOffsetTop', {
                get: function () {
                    return this.offsetTop + ( this.offsetParent ? this.offsetParent.documentOffsetTop : 0 );
                }
            } );

            window.Object.defineProperty( Element.prototype, 'documentOffsetLeft', {
                get: function () {
                    return this.offsetLeft + ( this.offsetParent ? this.offsetParent.documentOffsetLeft : 0 );
                }
            } );

            UiStateStore.update(componentId, (model) => {
                model.bubble.bubblePlaceholder = placeHolder;
            });
        }
        catch (ex) {
            ErrorLogger.log(ex);
            throw ex;
        }
    }

    static showBubble(event, componentId) {
        event.stopPropagation();

        let render = false;
        UiStateStore.update(componentId, (model) => {
            model.bubble.isBubbleVisible = true;
            model.bubble.position = BubblePositionCalculator.calculatePosition(event);
            render = !model.bubble.isBubbleRendered;
        });
        if(render) {
            UiActions._renderBubble(componentId);
        }
    }

    static hideBubble(componentId) {
        UiStateStore.update(componentId, (model) => {
            model.bubble.isBubbleVisible = false;
        });
    }

    static _renderBubble(componentId) {
        UiStateStore.update(componentId, (model) => {
            model.bubble.isBubbleRendered = true;

            ReactDOM.render(
                <LoginBubble componentId={componentId} />,
                model.bubble.bubblePlaceholder
            );
        });
    }

    static _registerComponent(componentId) {
        ModelStore.registerComponent(componentId);
        ParamStore.registerComponent(componentId);
        UiStateStore.registerComponent(componentId);
    }

    static _validateAndStoreGlobalParams(params, componentId) {

        if (!params.instanceId) {
            throw new Error('JLS Missing obligatory global parameter called instanceId');
        }

        if (!params.rootUrl) {
            throw new Error('JLS Missing obligatory global parameter called rootUrl');
        }

        if (!params.clsEndpoint) {
            throw new Error('JLS Missing obligatory global parameter called clsEndpoint');
        }

        if (!params.clsClientId) {
            throw new Error('JLS Missing obligatory global parameter called clsClientId');
        }

        if (!params.clsReturnUrl) {
            throw new Error('JLS Missing obligatory global parameter called clsReturnUrl');
        }

        if (!params.clsLoginUrl) {
            throw new Error('JLS Missing obligatory global parameter called clsLoginUrl');
        }

        if (!params.sentryUrl) {
            throw new Error('JLS Missing obligatory global parameter called sentryUrl');
        }

        if (!params.userLogData) {
            throw new Error('JLS Missing obligatory global parameter called userLogData');
        }

        if (!params.userLogData.anonymousId) {
            throw new Error('JLS Missing obligatory global parameter called userLogData.anonymousId');
        }

        if (!params.userLogData.lang) {
            throw new Error('JLS Missing obligatory global parameter called userLogData.lang');
        }

        if (!params.lang5) {
            throw new Error('JLS Missing obligatory global parameter called lang5');
        }

        if (!params.tracking) {
            throw new Error('JLS Missing obligatory global parameter called tracking');
        }

        if (!params.tracking.segment) {
            throw new Error('JLS Missing obligatory global parameter called tracking.segment');
        }

        if (!params.tracking.segment.containerProperty) {
            throw new Error('JLS Missing obligatory global parameter called tracking.segment.containerProperty');
        }

        if (!params.tracking.segment.registrationSource) {
            throw new Error('JLS Missing obligatory global parameter called tracking.segment.registrationSource');
        }

        if (!params.tracking.segment.loginSource) {
            throw new Error('JLS Missing obligatory global parameter called tracking.segment.loginSource');
        }

        if (!params.tracking.ga) {
            throw new Error('JLS Missing obligatory global parameter called tracking.ga');
        }

        if (!params.tracking.ga.termsCheckBox || !params.tracking.ga.termsCheckBox.category || !params.tracking.ga.termsCheckBox.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.termsCheckBox');
        }

        if (!params.tracking.ga.termsLink || !params.tracking.ga.termsLink.category || !params.tracking.ga.termsLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.termsLink');
        }

        if (!params.tracking.ga.privacyLink || !params.tracking.ga.privacyLink.category || !params.tracking.ga.privacyLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.privacyLink');
        }

        if (!params.tracking.ga.chooseOtherwiseLink || !params.tracking.ga.chooseOtherwiseLink.category || !params.tracking.ga.chooseOtherwiseLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.chooseOtherwiseLink');
        }

        if (!params.tracking.ga.productInformationCheckBox || !params.tracking.ga.productInformationCheckBox.category || !params.tracking.ga.productInformationCheckBox.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.productInformationCheckBox');
        }

        if (!params.tracking.ga.getStartedButton || !params.tracking.ga.getStartedButton.category || !params.tracking.ga.getStartedButton.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.getStartedButton');
        }

        if (!params.tracking.ga.federatedLoginLink || !params.tracking.ga.federatedLoginLink.category || !params.tracking.ga.federatedLoginLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.federatedLoginLink');
        }

        if (!params.tracking.ga.existingLoginLink || !params.tracking.ga.existingLoginLink.category || !params.tracking.ga.existingLoginLink.action) {
            throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.existingLoginLink');
        }

        let paramStoreModel = ParamStore.getModel(componentId);
        let modelStoreModel = ModelStore.getModel(componentId);
        let uiStateStoreModel = UiStateStore.getModel(componentId);

        // lang5 and rootUrl are preconditions for localization, do not change this order.
        paramStoreModel.instanceId = params.instanceId;
        paramStoreModel.tracking = params.tracking;

        paramStoreModel.lang5 = params.lang5;
        paramStoreModel.rootUrl = params.rootUrl;
        LocalizationFactory.initLocalization(componentId).then(() => { FormUiState.setReady(componentId); });

        if (params.initialCohort) {
            paramStoreModel.initialCohort = params.initialCohort;
        }

        if (params.targetCohort) {
            paramStoreModel.targetCohort = params.targetCohort;
        }

        paramStoreModel.clsEndpoint = params.clsEndpoint;
        paramStoreModel.clsClientId = params.clsClientId;
        paramStoreModel.clsReturnUrl = params.clsReturnUrl;
        paramStoreModel.clsLoginUrl = params.clsLoginUrl;

        // Tracking source overrides
        // Encode full URL as part of the returnUrl section and used to redirect not for XHRs.
        // Double encode sources for sure
        var trackingSourcesLogin = encodeURIComponent(
            'registrationSource=' +
            encodeURIComponent(params.tracking.segment.registrationSource) +
            '&loginSource=' +
            encodeURIComponent(params.tracking.segment.loginSource));

        // Do not encode the full URL because CLS re-encode after passed in the XHR JSON
        // Sources will be double encoded on CLS side
        var trackingSourcesReturnUrl =
            'registrationSource=' +
            encodeURIComponent(params.tracking.segment.registrationSource) +
            '&loginSource=' +
            encodeURIComponent(params.tracking.segment.loginSource);

        paramStoreModel.clsReturnUrl = paramStoreModel.clsReturnUrl.replace('TRACKING_SOURCE_PLACEHOLDER', trackingSourcesReturnUrl);
        paramStoreModel.clsLoginUrl = paramStoreModel.clsLoginUrl.replace('TRACKING_SOURCE_PLACEHOLDER', trackingSourcesLogin);

        paramStoreModel.sentryUrl = params.sentryUrl;
        paramStoreModel.userLogData = params.userLogData;

        if (params.formType) {
            modelStoreModel.formType = params.formType;
        }

        if (params.formVariants) {
            uiStateStoreModel.form.formVariants = params.formVariants;
        }

        if (params.localizationOverrides) {
            uiStateStoreModel.form.localizationOverrides = params.localizationOverrides;
        }

        if (paramStoreModel.initialCohort === InitialCohort.passwordlessRegistration) {
            ModelStore.update(componentId, (model) => {
                model.passwordMode = PasswordMode.passwordless;
            });
        }

        if (paramStoreModel.initialCohort === InitialCohort.singlePasswordRegistration) {
            ModelStore.update(componentId, (model) => {
                model.passwordMode = PasswordMode.singlePassword;
            });
        }

        if (params.callbacks) {
            paramStoreModel.callbacks = params.callbacks;
        }
    }

    static trackUiEvent(trackingValue, componentId) {
        JmServices.trackEvent(componentId, { trackingValue: trackingValue });
    }

    static showProductInformation(componentId) {
        JmServices.trackEvent(componentId, { trackingValue: TrackingAction.jlsChooseOtherwiseLinkClicked });
        UiStateStore.update(componentId, (model) => {
            model.form.showProductInformation = true;
        });
    }

    static termsLinkClicked(componentId) {
        JmServices.trackEvent(componentId, { trackingValue: TrackingAction.jlsTermsLinkClicked });
    }

    static privacyLinkClicked(componentId) {
        JmServices.trackEvent(componentId, { trackingValue: TrackingAction.jlsPrivacyPolicyLinkClicked });
    }

    static existingLoginLinkClicked(hasPassword, componentId) {
        JmServices.trackEvent(componentId, { isAsync: false, trackingValue: TrackingAction.jlsAlreadyExistingUserClickedLoginLink }).then(() => {
            UiActions._openLoginView(hasPassword, componentId);
        }).catch(() => {
            UiActions._openLoginView(hasPassword, componentId);
        });
    }

    static federatedLoginLinkClicked(clsLoginUrl, componentId) {
        // Aspirin needed for GA page leave tracking as no callback
        window.setTimeout(() => {
            JmServices.trackEvent(componentId, { isAsync: false, trackingValue: TrackingAction.jlsFederatedUserClickedLoginLink }).then(() => {
                UiActions._redirectAfterLinkClicked(clsLoginUrl);
            }).catch(() => {
                UiActions._redirectAfterLinkClicked(clsLoginUrl);
            });
        }, 500)
    }

    static _openLoginView(hasPassword, componentId) {
        if (hasPassword) {
            FormActions.changeFormType(componentId, FormType.login);
        } else {
            // PWD less flow
            FormActions.redirectToForgotPwd(componentId);
        }
    }

    static _redirectAfterLinkClicked(url) {
        window.top.location = url;
    }
}


/** WEBPACK FOOTER **
 ** ./src/logic/ui-actions.js
 **/